import script from "./preview.vue?vue&type=script&setup=true&lang=ts"
export * from "./preview.vue?vue&type=script&setup=true&lang=ts"

import "./preview.vue?vue&type=style&index=0&id=3d764f25&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d764f25"]])

export default __exports__